import React, { Component } from 'react';
import {
  ColumnChooser,
  ColumnDirective,
  ColumnsDirective,
  ContextMenu,
  FilterSettingsModel,
  Freeze,
  GridComponent,
  Inject,
  Page,
  Reorder,
  Resize,
  VirtualScroll,
} from '@syncfusion/ej2-react-grids';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import moment from 'moment';
import { DatePickerComponent } from '@syncfusion/ej2-react-calendars';
import { FcNext, FcPrevious } from 'react-icons/fc';
import { ThemeContext } from '../../context/theme.context';
import Message from '../../utils/Message/Message';
import { TreeViewComponent } from '@syncfusion/ej2-react-navigations';
import '../CloudScheduler/gantt.css';
import { FiAlertTriangle } from 'react-icons/fi';
import { GetSchedulerLoad } from '../../services/CloudScheduler/CloudSchedulerServices';
import {
  ButtonComponent,
  ChipDirective,
  ChipListComponent,
  ChipsDirective,
} from '@syncfusion/ej2-react-buttons';
import { loadingShow } from '../../App';
import { CloudScheduler } from './CloudScheduler';
interface IProps {
  isLoad: boolean;
  queryForLoad: string;
  handleDatePickerChange: (args: Date, weekCount: number) => void;
  fitInGant: (args: Date) => void;
  refreshToken: string;
}
interface IState {
  currentIcon: any;
  status: boolean;
  allowRender: boolean;
  loadGant: Array<any>;
  columnDate: Array<any>;
  datePickerValue: Date;
  fields: any;
  expandableButton: boolean;
  isLoad: boolean;
}
export default class Load extends Component<IProps, IState> {
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };

  private theLoadGrid: GridComponent;
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  private DPC: DatePickerComponent;
  public treeObj: TreeViewComponent;
  private isRenderAllow: boolean = false;
  private theCurrentDateField: Array<any> = [];
  private theInitialDate: Date = new Date();
  private weekCount: number = 3;
  constructor(prop: IProps) {
    super(prop);
    const isLoad = this.props.isLoad;
    this.theLoadGrid = new GridComponent({});
    this.treeObj = new TreeViewComponent({});
    this.state = {
      currentIcon: <FaAngleDown size='14px' />,
      loadGant: [],
      status: false,
      columnDate: [],
      allowRender: false,
      datePickerValue: CloudScheduler.start_date,
      fields: {
        dataSource: [],
        id: '',
        parentID: '',
        text: '',
        hasChildren: '',
      },
      expandableButton: true,
      isLoad: isLoad,
    };
    this.DPC = new DatePickerComponent({});
  }
  private theWeekOfDay = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  dateGenerator(start_date: Date, weekNumber: number) {
    var theDateObject: Array<any> = [];
    var theDate: Date = new Date(start_date);
    for (var i = 0; i < weekNumber * 7; i++) {
      theDateObject.push({
        field: moment(theDate).format('yyy-MM-DD'),
        dayName:
          this.theWeekOfDay[moment(theDate).toDate().getDay()] +
          ' ' +
          moment(theDate).toDate().getDate(),
      });
      theDate.setDate(theDate.getDate() + 1);
    }
    return theDateObject;
  }
  async componentDidUpdate(
    prevProps: Readonly<IProps>,
    prevState: Readonly<IState>,
    snapshot?: any
  ): Promise<void> {
    if (prevProps.refreshToken !== this.props.refreshToken) {
      if (this.props.refreshToken !== '') {
        await this.getCapacity(this.props.queryForLoad);
      }
    }
    if (prevProps.queryForLoad !== this.props.queryForLoad) {
      await this.getCapacity(this.props.queryForLoad);
    }
    if (this.context.isLoadAllowChange) {
      this.isRenderAllow = true;
      if (CloudScheduler.isDateChangeRequest) {
        this.theInitialDate = new Date(CloudScheduler.start_date);
        this.setState({
          datePickerValue: CloudScheduler.start_date,
          expandableButton: !this.context.isLoadAllowChange,
        });
        var date = CloudScheduler.start_date;
        this.DPC.value = date;
        this.reCreateGridColumn(this.DPC.value, this.weekCount);
      }
      this.context.setLoadAllowChange(false);
    }
  }
  expand = () => {
    var element = document.getElementById('expandable');
    if (this.state.status) {
      element?.classList.remove('layoutExpand');
      element?.classList.add('layoutCollapse');
      // this.setState({ currentIcon: <FaAngleDown size='14px' /> });
    } else {
      element?.classList.remove('layoutCollapse');
      element?.classList.add('layoutExpand');
      // this.setState({ currentIcon: <FaAngleUp size='14px' /> })
    }
    this.setState({
      status: !this.state.status,
      currentIcon: this.state.status ? (
        <FaAngleDown size='14px' />
      ) : (
        <FaAngleUp size='14px' />
      ),
      allowRender: true,
    });
  };
  componentDidMount() {}
  componentWillUnmount(): void {
    this.isRenderAllow = false;
  }
  async getCapacity(range: string) {
    // if (CloudScheduler.tradeExchangeIds !== '') {
    //   range = range.replace(
    //     `$${CloudScheduler.tradeExchangeIds}`,
    //     `$$${CloudScheduler.tradeExchangeText}`
    //   );
    // }
    await GetSchedulerLoad(range)
      .then((res) => res.json())
      .then((response) => {
        let filteredData: Array<any> = [];
        loadingShow(false);
        response.map((el: any) => {
          var findIndex = filteredData.findIndex((indexEl) => {
            return el.resourceName?.trim() === indexEl.resourceName?.trim();
          });
          if (findIndex !== -1) {
            if (filteredData[findIndex][`${el.dayName}data`]) {
              filteredData[findIndex][`${el.dayName}data`].load += el.load;
              filteredData[findIndex][`${el.dayName}data`].capacity +=
                el.capacity;
            } else {
              filteredData[findIndex][`${el.dayName}`] = el.dayName;
              filteredData[findIndex][`${el.dayName}data`] = {
                ...el,
              };
            }
          } else {
            filteredData.push({
              ...el,
              [`${el.dayName}`]: el.dayName,
              [`${el.dayName}data`]: {
                ...el,
              },
            });
          }
        });
        if (this.isRenderAllow) {
          this.setState({ loadGant: filteredData });
        }
      })
      .catch((e) => {
        loadingShow(false);
        Message.error('Something went wrong!!!. Code:Load-175');
        console.log(e);
      });
  }
  ConvertToDate(val: any) {
    var num = parseInt(val.substring(6, 19));
    var date = moment(num).format('yyyy-MM-DD');
    return date;
  }

  dataTemplate(args: string, comming: any) {
    var cond = comming[args];
    let current_content = <div></div>;
    if (cond) {
      var numberCapacity = Number(comming[`${cond}data`].capacity);
      var numberLoad = Number(comming[`${cond}data`].load);
      var theBackGroundColor = '';
      var theTextColor = '';
      var theResult = 0;
      if (numberCapacity !== 0) {
        theResult = Number(((numberLoad / numberCapacity) * 100).toFixed(2));
      }
      current_content = <div>{theResult}%</div>;
      if (theResult < 79) {
        theBackGroundColor = '#0d6efd';
        theTextColor = 'var(--dark-text)';
      } else if (theResult > 80 && theResult <= 100) {
        theBackGroundColor = '#008000';
        theTextColor = 'var(--dark-text)';
      } else if (theResult < 100 || theResult > 100) {
        theBackGroundColor = '#C90016';
        theTextColor = 'white';
      }
      if (theResult === Infinity) {
        current_content = (
          <div>
            <FiAlertTriangle size={25} />
          </div>
        );
      }
      let theLoad = comming[`${cond}data`].load;
      let theCapacity = comming[`${cond}data`].capacity;
      if (isNaN(theLoad)) {
        theLoad = 0;
      }
      if (isNaN(theCapacity)) {
        theCapacity = 0;
      }
      return (
        <div
          style={{
            display: 'flex',
            color: theTextColor,
            justifyContent: 'space-between',
            width: '100%',
          }}
          className='animation'
        >
          <div
            style={{
              padding: 5,
              marginRight: 5,
              borderRadius: 5,
              backgroundColor: '#F4B400',
              width: '30%',
              color: 'black',
              textAlign: 'right',
            }}
          >
            {theLoad?.toFixed(2)}
          </div>
          <div
            style={{
              marginRight: 5,
              padding: 5,
              borderRadius: 5,
              backgroundColor: '#36454F',
              width: '30%',
              textAlign: 'right',
              color: 'white',
            }}
          >
            {theCapacity?.toFixed(2)}
          </div>
          <div
            style={{
              padding: 5,
              borderRadius: 5,
              backgroundColor:
                Number(numberCapacity) === 0 ? '#C90016' : theBackGroundColor,
              width: '39%',
              textAlign: 'right',
              color: 'white',
            }}
          >
            {current_content}
          </div>
        </div>
      );
    } else {
      return <div></div>;
    }
  }
  dataCapacityTemplate(args: any) {
    let totalCapacity = 0;
    let totalLoad = 0;
    totalCapacity = 0;
    let current_content = <div></div>;
    var theResult = 0;
    var theBackGroundColor = '';
    var theTextColor = '';
    if (totalCapacity !== 0) {
      theResult = Number(((totalLoad / totalCapacity) * 100).toFixed(2));
    }
    current_content = <div>{theResult}%</div>;
    if (theResult < 79) {
      theBackGroundColor = '#0d6efd';
      theTextColor = 'var(--dark-text)';
    } else if (theResult > 80 && theResult <= 100) {
      theBackGroundColor = '#008000';
      theTextColor = 'var(--dark-text)';
    } else if (theResult < 100) {
      theBackGroundColor = '#C90016';
      theTextColor = 'white';
    }
    this.theCurrentDateField.map((theDate) => {
      let theCurrent = args[`${theDate.field}data`];
      if (theCurrent) {
        totalCapacity += theCurrent.capacity;
        totalLoad += theCurrent.load;
      }
    });
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: 5,
          borderRadius: 5,
        }}
      >
        <div
          style={{ backgroundColor: '#F4B400', width: '30%', borderRadius: 5 }}
        >
          <span style={{ color: 'black', padding: 1 }}>{totalLoad}</span>
        </div>
        <div style={{ width: '%10' }}>
          <span>-</span>
        </div>
        <div
          style={{ backgroundColor: '#36454F', width: '30%', borderRadius: 5 }}
        >
          <span style={{ padding: 1 }}>{totalCapacity}</span>
        </div>
        <div
          style={{
            padding: 5,
            borderRadius: 5,
            backgroundColor:
              Number(totalCapacity) === 0 ? '#C90016' : theBackGroundColor,
            width: '20%',
            textAlign: 'right',
            color: 'white',
          }}
        >
          {current_content}
        </div>
      </div>
    );
  }
  datePickerOnChange(args: any) {
    CloudScheduler.start_date = args.value;
    // this.dateGenerator(args.value);
    this.props.handleDatePickerChange(new Date(args.value), this.weekCount);
    this.reCreateGridColumn(args.value, this.weekCount);
  }
  reCreateGridColumn = (date: Date, selectedWeek: number) => {
    this.theCurrentDateField = this.dateGenerator(date, selectedWeek);
    var theArray = [
      {
        field: 'resourceName',
        headerText: 'Trade',
        width: 60.5,
        freeze: 'Left',
      },
      ...this.theCurrentDateField.map((el) => {
        return {
          field: el.field,
          headerText: el.dayName,
          template: this.dataTemplate.bind(this, el.field),
          width: 170,
        };
      }),
    ];
    theArray.push({
      field: 'totalCapacity',
      headerText: 'T. Load - T. Capacity-%',
      template: this.dataCapacityTemplate.bind(this),
      width: 170,
      freeze: 'Right',
    });
    if (this.theLoadGrid) {
      this.theLoadGrid.frozenColumns = 1;
      this.theLoadGrid.columns = theArray as any;
      this.theLoadGrid.refreshColumns();
    }
  };
  previousWeekButton() {
    var theCurrentDate = new Date(this.DPC.value);
    theCurrentDate.setDate(theCurrentDate.getDate() - this.weekCount * 7);
    this.props.handleDatePickerChange(new Date(theCurrentDate), this.weekCount);
    this.DPC.value = theCurrentDate;
    localStorage.setItem('load_start_date', theCurrentDate.toString());
    this.DPC.refresh();
    this.reCreateGridColumn(theCurrentDate, this.weekCount);
  }
  nextWeekButton() {
    var theCurrentDate = new Date(this.DPC.value);
    theCurrentDate.setDate(theCurrentDate.getDate() + this.weekCount * 7);
    this.props.handleDatePickerChange(new Date(theCurrentDate), this.weekCount);
    this.DPC.value = theCurrentDate;
    localStorage.setItem('load_start_date', theCurrentDate.toString());
    this.DPC.refresh();
    this.reCreateGridColumn(theCurrentDate, this.weekCount);
  }
  componentCreated() {
    this.reCreateGridColumn(CloudScheduler.start_date, this.weekCount);
  }
  handlerOfFitGant() {
    this.DPC.value = this.theInitialDate;
    this.reCreateGridColumn(this.DPC.value, this.weekCount);
    this.props.fitInGant(CloudScheduler.start_date);
  }
  handleToChangeWeekNumber(args: any) {
    this.weekCount = args.data.value;
    this.DPC.value = this.theInitialDate;
    this.props.handleDatePickerChange(new Date(this.DPC.value), this.weekCount);
    this.reCreateGridColumn(this.DPC.value, this.weekCount);
  }
  render() {
    return (
      <div>
        <div>
          <div>
            <div className='time-picker-content'>
              <div className='time-picker-navigate'>
                <FcPrevious
                  size={30}
                  onClick={this.previousWeekButton.bind(this)}
                />
                <DatePickerComponent
                  onChange={this.datePickerOnChange.bind(this)}
                  ref={(el: DatePickerComponent) => (this.DPC = el)}
                  cssClass='e-customStyle'
                  value={this.state.datePickerValue}
                  format={'dd/MM/yyyy'}
                  id='cloudscheduler-load'
                  delayUpdate={true}
                  width={200}
                />
                <FcNext size={30} onClick={this.nextWeekButton.bind(this)} />
                {/* <ButtonComponent
                  onClick={this.handlerOfFitGant.bind(this)}
                  style={{ marginLeft: 10, width: 200 }}
                >
                  Default View
                </ButtonComponent> */}
                <ButtonComponent
                  onClick={() => {
                    loadingShow(true);
                    this.getCapacity(this.props.queryForLoad);
                  }}
                  style={{ marginLeft: 10, width: 100, marginRight: 5 }}
                >
                  Refresh
                </ButtonComponent>
                <ChipListComponent
                  id='chip-filter-cp'
                  selectedChips={[2]}
                  selection='Single'
                  // ref={(el: ChipListComponent) => (chips = el)}
                  click={this.handleToChangeWeekNumber.bind(this)}
                >
                  <ChipsDirective>
                    <ChipDirective
                      text={`1 Week`}
                      cssClass={`e-chip-text1`}
                      key={'1 Week'}
                      value={1}
                    />
                    <ChipDirective
                      text={`2 Week`}
                      cssClass={`e-chip-text2`}
                      key={'2 Week'}
                      value={2}
                    />
                    <ChipDirective
                      text={`3 Week`}
                      cssClass={`e-chip-text3`}
                      key={'3 Week'}
                      value={3}
                    />
                  </ChipsDirective>
                </ChipListComponent>
                {/* <ButtonComponent
                  onClick={this.handleToChangeWeekNumber.bind(this, 1)}
                  style={{ marginLeft: 10, width: 200 }}
                >
                  1 Week
                </ButtonComponent>
                <ButtonComponent
                  onClick={this.handleToChangeWeekNumber.bind(this, 2)}
                  style={{ marginLeft: 10, width: 200 }}
                >
                  2 Week
                </ButtonComponent>
                <ButtonComponent
                  onClick={this.handleToChangeWeekNumber.bind(this, 3)}
                  style={{ marginLeft: 10, width: 200 }}
                >
                  3 Week
                </ButtonComponent> */}
              </div>
            </div>
            <div className='grid-scheduler-load-wrapper '>
              <GridComponent
                id='grid-scheduler-load'
                dataSource={this.state.loadGant}
                ref={(g: GridComponent) => (this.theLoadGrid = g)}
                filterSettings={this.FilterOptions}
                // created={this.componentCreated.bind(this)}
                pageSettings={{
                  pageSize: 100,
                  pageCount: 10,
                }}
                style={{ marginTop: '10px', overflow: 'scroll' }}
                gridLines='Both'
                height={210}
                allowResizing={true}
                dataBound={(args: any) => {}}
                frozenColumns={1}
                frozenRows={1}
                enableHover={false}
              >
                <ColumnsDirective>
                  <ColumnDirective
                    field={'resourceName'}
                    headerText={'Trade'}
                    isPrimaryKey={true}
                    freeze='Left'
                    textAlign='Right'
                  />
                  <ColumnDirective
                    field={'totalCapacity'}
                    headerText={'Total Capacity'}
                    freeze='Right'
                    textAlign='Right'
                  />
                </ColumnsDirective>
                <Inject
                  services={[
                    ContextMenu,
                    VirtualScroll,
                    Reorder,
                    Page,
                    Resize,
                    ColumnChooser,
                    Freeze,
                  ]}
                />
              </GridComponent>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
